<template>
  <div :style='config.InnerStyle'>{{ TextValue || value}}</div>
</template>
<script>
import base from "matrix.node.ui/field.js";
export default {
  mixins: [base.view(Number)],
};
</script>